import { useState } from "react";
import { LinearProgress, Tabs } from '../../tailwindcomponents';

import ChecklistsOverview from "./ChecklistsOverview";
import ChecklistTemplate from "./ChecklistTemplate";
import { useQueryTab } from "../../utils/usePersistedTab";

const Checklists = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const { tabValue, setTabValue } = useQueryTab("tab", 0);

    return (
        <div>
            {loading && <LinearProgress />}
            <Tabs
                tabNames={["Checklists", "Template"]}
                tabValue={tabValue}
                onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
            />
            {tabValue === 0 && <ChecklistsOverview setLoading={setLoading} loading={loading} />}
            {tabValue === 1 && <ChecklistTemplate setLoading={setLoading} />}
        </div>
    )
}

export default Checklists;